import createLucideIcon from '../createLucideIcon';

const ArrowBigLeftDash = createLucideIcon('ArrowBigLeftDash', [
  ['path', { d: 'M19 15V9', key: '1hci5f' }],
  ['path', { d: 'M15 15h-3v4l-7-7 7-7v4h3v6z', key: '16tjna' }],
]);

export default ArrowBigLeftDash;
